module.exports = __webpack_public_path__ + "static/media/millard.5d71ef52.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/millard.png
// module id = 64
// module chunks = 0